import {
  faFlagCheckered,
  faListCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

// The house convention, as most stored final-quiz titles already read.
export const finalQuizTitle = (lessonTitle: string | undefined) =>
  lessonTitle ? `${lessonTitle} Final Quiz` : 'Final Quiz';

// Which quiz a question belongs to, easy to spot at a glance.
export function QuizBadge({ final }: { final: boolean }) {
  return (
    <Badge $final={final}>
      <FontAwesomeIcon icon={final ? faFlagCheckered : faListCheck} />
      {final ? 'Final quiz' : 'Topic quiz'}
    </Badge>
  );
}

const Badge = styled.span<{ $final: boolean }>`
  align-items: center;
  background: ${(p) =>
    p.$final
      ? 'var(--grey-blue-400)'
      : 'color-mix(in srgb, var(--blue) 14%, transparent)'};
  border: 1px solid
    ${(p) => (p.$final ? 'var(--grey-blue-400)' : 'var(--blue)')};
  border-radius: 999px;
  color: ${(p) => (p.$final ? 'var(--white)' : 'var(--grey-900)')};
  display: inline-flex;
  font-size: 0.8125rem;
  font-weight: 600;
  gap: 0.4rem;
  padding: 0.2rem 0.7rem;
  white-space: nowrap;
`;
